module.exports = __webpack_public_path__ + "img/like.b43cb791.svg";